import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=19ab5fe5"
import script from "./sendEmail.ts?vue&type=script&lang=js&external"
export * from "./sendEmail.ts?vue&type=script&lang=js&external"
import style0 from "./sendEmail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports